import { takeLatest, put, call } from 'redux-saga/effects';
import { getResponseError } from '@utils/error';
import { AxiosError } from 'axios';

import { UserProfile } from '@models/User';
import { AuthApi, SignInWithUsernameAuthParams } from '@apis/AuthApi';
import { history } from '@utils/history';
import { SagaPayload } from '@utils/typescript';
import { authAccessTokenSet } from '@components/Auth';
import i18n from '@components/i18n';
import { toastShow } from '@components/ToastProvider';

import { usernameSignIn, usernameSignInError } from './action';
import { AFTER_SIGN_IN_PATH } from '@config';

function* handleUsernameSignIn({ payload }: SagaPayload<SignInWithUsernameAuthParams>) {
  try {
    const { accessToken } = (yield call(AuthApi.signInWithUsername, payload)) as UserProfile;
    yield put(authAccessTokenSet(accessToken));
    const from = history.location.state?.from;
    const path = from ? `${from.pathname}${from.search}` : AFTER_SIGN_IN_PATH;
    history.navigate(path);
    yield put(toastShow({ status: 'success', body: i18n.t('toast.signedIn') }));
  } catch (e) {
    const { error } = getResponseError(e as AxiosError);
    yield put(usernameSignInError({ errors: { password: error } }));
  }
}

export default function* () {
  yield takeLatest(usernameSignIn, handleUsernameSignIn);
}
